import { instance } from '@/services/avik-api-gateway'
import { CustomerAvailabilityStatus } from '@/types/customer-availability-status'
import { AxiosResponse } from 'axios'

export function getCustomerAvailabilityStatus(): Promise<
  AxiosResponse<CustomerAvailabilityStatus[]>
> {
  return instance.get(`/customer-availability-status`)
}
